/* prettier-ignore */
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ValidIdGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const id = next.params.id;
      const isValidId = /^\d+$/.test(id); // Verifica si el id es un número válido
      if (!isValidId) {
        // Si el id no es válido, redirigir a una página de error o a una ruta específica
        return this.router.parseUrl('/404'); // Cambia '/404' por la ruta deseada para el manejo de 404
      }
      return true;
  }
}
